import { useRecord } from "./useRecord";

export function useGroup(groupId?: string | null) {
  return useRecord("tag", groupId, { name: "useGroup" });
}
